
export default {
  props: {},
  data() {    
    return {};
  },
  computed: {},
  created() {

  },
  mounted() {},
  watch: {},
  methods: {
    // 下一步
    nextPage(path) {
      if (this.show) {
        this.$modal("当前页面存在未保存数据，是否进入下一步操作？").then(() => {
          // 进入下一个页面
          this.$go(path);
        });
      } else {
        // 进入下一个页面
        this.$go(path);
      }
    },
    // 返回
    backBtn() {
      if (this.show) {
        this.$confirm("页面可能有未保存的内容是否继续退出?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$store.dispatch("user/getInfo");
          this.$router.go(-1);
        });
      } else {
        this.$store.dispatch("user/getInfo");
        this.$router.go(-1);
      }
    },
      

  },
  components: {},
};